import moment from "moment";
import React, { useEffect, useState } from "react";

interface TimerProps {
  dateObject: string;
  onTimerEnd?: () => void;
}

const Timer: React.FC<TimerProps> = ({ dateObject, onTimerEnd }) => {
  const [remainingTime, setRemainingTime] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = moment();
      const eta = moment(dateObject);
      const duration = moment.duration(eta.diff(currentTime));
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      const remainingTime = `${hours}h ${minutes}m ${seconds}s`;
      setRemainingTime(remainingTime);

      if (hours === 0 && minutes === 0 && seconds === 0 && onTimerEnd) {
        clearInterval(intervalId);
        onTimerEnd();
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [dateObject, onTimerEnd]);

  return <strong>{remainingTime}</strong>;
};

export default Timer;
